/**
 * @Author: Zero
 * @Date: 2026-08-10 15:37:25
 * @Explain: 测试玩家 - 埋点事件
 */
export default {
  /** 测试玩家 - 二次确认 - 编辑失败上报 */
  560: 'saveTesterDoubleOptin',
  /** 测试玩家- 二次确认 - 获取详情失败上报 */
  561: 'getTesterDoubleOptinDetails',
};
